import React, { useEffect } from "react";
import { HeaderImgSection } from '../../Header/HeaderImgSection'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import silder from '../../../images/Website Development & Designing/Website-Development-&-Designing-1900-220.png'
import sidebar from '../../../images/Website Development & Designing/Best-website-development-companies.png'
import why_1 from '../../../images/why-1.webp'

function WebsiteDevelopmentDesigning() {
  useEffect(() => {
    document.title = "Website Development || OZVASERVICE"
 }, []);
  return (
    <>
      <HeaderImgSection img={silder} hTitle={'Services'} title={"Website Development"}></HeaderImgSection>
      <Container className='my-5'>
        <h1 className='text-center text-primary fw-semibold '>Website Development</h1>
        <p className='text-center'>At OZVA SERVICE, we specialize in developing visually stunning and highly functional websites tailored to the unique needs of our clients. We understand that a website is often the first point of contact for potential customers — making it a vital tool for building credibility, earning trust, and driving online success.</p>

        <Row className='my-5 align-items-center'>
          <Col lg={6} className='mb-lg-0 mb-3 '>
            <h2 className='text-dark fw-semibold'>Leading Website Development Experts</h2>
            <p>OZVA SERVICE is a forward-thinking, technology-driven company offering end-to-end website development solutions. We transform digital ideas into reality by leveraging the latest programming languages and frameworks, catering to a diverse range of industries such as IT, travel, hospitality, logistics, e-commerce, and more.  </p>
            <p>Our development approach focuses on clean layouts, compelling visuals, intuitive navigation, and seamless user experiences. Whether it's a professional business site, a dynamic web platform, or a feature-rich e-commerce store, every solution we deliver is secure, scalable, and tailored to meet your unique business goals.</p>
            <p>More than just a web development company, we are committed to delivering exceptional results without compromising on quality. Our in-house team of expert designers and developers work closely with clients to ensure each website reflects their brand identity and core values. We offer the perfect blend of affordability and premium service — helping businesses, from startups to enterprises, stand out and grow in the digital space.</p>
          </Col>
          <Col lg={6} className='d-flex justify-content-center align-items-center'>
            <div className="">
              <img src={sidebar} className='img-fluid rounded-2' alt="" />
            </div>
          </Col>
        </Row>
        <h2 className='fw-semibold mb-4'>Why Should You Choose OZVA SERVICE?</h2>
              <ul>
                <li>We follow rigorous quality assurance processes, including comprehensive testing and validation, to ensure seamless project delivery.</li>
                <li>We align with your goals, timelines, and budget through clear, transparent communication at every step.</li>
                <li>We uphold strict data privacy standards and handle your project with complete confidentiality.</li>
                <li>We build strategic, results-driven websites backed by extensive industry experience.</li>
                <li>We prioritize speed, scalability, and mobile responsiveness in every solution we craft.</li>
              </ul>
        {/* <Row className='my-5 align-items-center'>
            <Col lg={6} className='d-flex justify-content-center align-items-center'>
                <div className="">
                  <img src={why_1} className='img-fluid rounded-2' alt="" style={{height: "500px"}} />
                </div>
            </Col>
            <Col lg={6} className='mb-lg-0 mb-3 '>
              
            </Col>            
        </Row> */}
      </Container>
    </>
  )
}

export default WebsiteDevelopmentDesigning